'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const CID = require('cids');

const configure = require('../lib/configure');

const toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(api => {
  return async (paths, options = {}) => {
    paths = Array.isArray(paths) ? paths : [paths];
    const res = await (await api.post('pin/add', {
      timeout: options.timeout,
      signal: options.signal,
      searchParams: toUrlSearchParams(_objectSpread({
        arg: paths.map(path => "".concat(path))
      }, options)),
      headers: options.headers
    })).json();
    return (res.Pins || []).map(cid => ({
      cid: new CID(cid)
    }));
  };
});